import moment from 'moment';

const ELECTION_TYPE_COUNCIL = 2;
const calcMandates = (cities, elections) => {
  let mandates = 0;
  let absolutes = 0;
  let mandatesSpo = 0;
  let mandatesOvp = 0;
  let mandatesFpo = 0;
  cities.forEach((city) => {
    const councilElections = elections.filter((election) => election.city === city.id && election.type === ELECTION_TYPE_COUNCIL);
    const latestCouncilElection = councilElections.sort((a, b) => moment(a).diff(moment(b)))[0];
    let cityMandates = 0;
    latestCouncilElection.parties.forEach((item) => { cityMandates += item.mandates; });
    mandates += cityMandates;
    latestCouncilElection.parties.forEach((item) => {
      if (item.party === 1 && item.mandates / cityMandates > 0.5) {
        absolutes += 1;
      }
      if (item.party === 1) {
        mandatesSpo += item.mandates;
      }
      if (item.party === 2) {
        mandatesOvp += item.mandates;
      }
      if (item.party === 3) {
        mandatesFpo += item.mandates;
      }
    });
  });
  return {
    mandates, absolutes, mandatesSpo, mandatesOvp, mandatesFpo,
  };
};

const getSum = (cities, field) => {
  let sum = 0;
  cities.forEach((city) => {
    const cityValue = (city[field] ? (city[field][Object.keys(city[field]).sort((a, b) => b - a)[0]] || 0) : 0);
    sum += cityValue;
  });
  return sum;
};

export default function DistrictsRowsMapper(
  local,
  cities,
  districts,
  elections,
  officials,
) {
  let rows;
  if (cities && districts && elections && officials) {
    rows = districts.map((district) => {
      const filtered = cities.filter((item) => item.district === district.id);
      const {
        mandates, absolutes, mandatesSpo, mandatesOvp, mandatesFpo,
      } = calcMandates(filtered, elections);
      const officialsMaleFemale = getSum(filtered, 'officials');
      const officialsFemale = getSum(filtered, 'officialsFemale');
      const citizens = getSum(filtered, 'citizens');
      const members = getSum(filtered, 'members');
      const membersAverageAge = Math.round((getSum(filtered, 'membersAverageAge') / filtered.length) * 100) / 100;
      const officialsAverageAge = Math.round((getSum(filtered, 'officialsAverageAge') / filtered.length) * 100) / 100;
      const mayors = officials.filter((official) => official.district === district.id && official.type === 1 && official.party === 1);

      const row = {
        id: district.id,
        gkz: district.gkz,
        name: district.name,
        cities: filtered.length,
        mayors: mayors.length,
        mayorsPercent: Math.round((mayors.length / filtered.length) * 10000) / 100,
        absolutes,
        absolutesPercent: Math.round((absolutes / filtered.length) * 10000) / 100,
        mandates,
        mandatesSpo,
        mandatesSpoPercent: mandates > 0 ? Math.round((mandatesSpo / mandates) * 10000) / 100 : 0,
        mandatesOvp,
        mandatesOvpPercent: mandates > 0 ? Math.round((mandatesOvp / mandates) * 10000) / 100 : 0,
        mandatesFpo,
        mandatesFpoPercent: mandates > 0 ? Math.round((mandatesFpo / mandates) * 10000) / 100 : 0,
        officials: officialsMaleFemale,
        officialsFemale,
        officialsFemalePercent: officialsMaleFemale > 0 ? Math.round((officialsFemale / officialsMaleFemale) * 10000) / 100 : 0,
        citizens,
        members,
        membersPercent: citizens > 0 ? Math.round((members / citizens) * 10000) / 100 : 0,
        membersAverageAge,
        officialsAverageAge,
      };
      return row;
    });
  }
  return rows;
}
